import * as React from "react";

import { AccessReportsWizardTemplate } from "@app/access-reports/shared";
import { TemplateNode, TemplateNodeTypeEnum } from "@app/access-reports/admin/template-update";
import { JSX } from "react";

export interface TemplateUpdateProps {
  selectedClients: string[];
  selectedNode: TemplateNode;
  selectedNodeType: TemplateNodeTypeEnum;
  setSelectedClients: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedNode: React.Dispatch<React.SetStateAction<TemplateNode>>;
  setSelectedNodeType: React.Dispatch<React.SetStateAction<TemplateNodeTypeEnum>>;
  setTemplate: React.Dispatch<React.SetStateAction<AccessReportsWizardTemplate>>;
  template: AccessReportsWizardTemplate;
}

type TemplateUpdateProviderProps = { children: React.ReactNode };

export const TemplateUpdateContext = React.createContext<Partial<TemplateUpdateProps>>({});

export function TemplateUpdateProvider(props: TemplateUpdateProviderProps): JSX.Element {
  const [selectedClients, setSelectedClients] = React.useState<string[]>([]);
  const [selectedNode, setSelectedNode] = React.useState<TemplateNode>(null);
  const [selectedNodeType, setSelectedNodeType] = React.useState<TemplateNodeTypeEnum>(null);
  const [template, setTemplate] = React.useState<AccessReportsWizardTemplate>(null);

  return (
    <TemplateUpdateContext.Provider
      value={{
        selectedClients,
        selectedNode,
        selectedNodeType,
        setSelectedClients,
        setSelectedNode,
        setSelectedNodeType,
        setTemplate,
        template,
      }}
    >
      {props.children}
    </TemplateUpdateContext.Provider>
  );
}